var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 331,
    viewBox: "0 0 223 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 27H72V102H111V27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 181H72V256H111V181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 124H72V160H111V124Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 89H10V338H49V89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 242H133V317H172V242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 89H133V164H172V89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 185H133V221H172V185Z",
    fill: "#E70488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 7H195V257H233V7Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 331,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.62af92e261114a16987933b6e2e51c88.svg";
export { ForwardRef as ReactComponent };